module.exports = __webpack_public_path__ + "img/ppc_icon.e83468b8.png";